import moment from 'moment'

export function shouldHighlightMissingInvoicePdf(isInternalAdmin, isInvoicePdfGenerate) {
  return isInternalAdmin && !isInvoicePdfGenerate
}

export function shouldShowRegenerateInvoice(isInvoicePdfGenerate, isDelivered, status) {
  return isInvoicePdfGenerate && !isDelivered && status !== 'Paid'
}

export function getAdminInvoiceRowTooltip(deliveredOn, hasNoPdf) {
  const deliveryText = deliveredOn
    ? `Delivered on ${moment(deliveredOn).format('MMM DD, YYYY')}`
    : 'Not delivered'

  return [deliveryText, hasNoPdf ? 'No PDF' : null].filter(Boolean).join(' · ')
}
